export default {
  // 工具栏
  autoMap: '自动建图',
  stopMap: '停止建图',
  syncMap: '同步地图',
  query: '查询',
  reset: '重置',
  tableView: '表格',
  cardView: '卡片',
  inputDeviceSn: '请输入设备 SN',
  inputMapName: '请输入地图名称',

  // 表格列
  mapName: '地图名称',
  deviceSn: '设备 SN',
  createTime: '创建时间',
  action: '操作',
  mapFile: '地图文件',
  previewImage: '预览图',

  // 通用
  details: '详情',
  delete: '删除',
  more: '更多',
  loading: '加载中...',
  noData: '暂无地图数据',

  // 自动建图/停止建图模态框
  startAutoMapTitle: '自动建图',
  stopAutoMapTitle: '停止建图',
  startAutoMapBtn: '开始建图',
  stopAutoMapBtn: '停止建图',
  selectDevice: '选择机器狗',
  online: '在线',
  offline: '离线',
  unnamedDevice: '未命名设备',
  noDevice: '暂无机器狗',

  // 同步地图模态框
  syncMapTitle: '同步地图',
  selectMap: '选择地图',
  selectAllMaps: '选择地图 ({count}/{total})',
  noSyncMap: '该机器狗暂无可同步地图',
  stepTip: '点击步骤条可快速切换',

  // 确认对话框
  confirmDeleteTitle: '确认删除地图「{name}」吗？',
  confirmDeleteContent: '删除后不可恢复。',
  confirmDelete: '确认删除',
  cancel: '取消',

  // 提示信息
  offlineDeviceWarning: '离线机器狗不可选择',
  pleaseSelectOnlineDevice: '请选择在线机器狗',
  pleaseSelectMap: '请选择要同步的地图',
  autoMapCommandSent: '已发送自动建图指令',
  autoMapFailed: '自动建图失败',
  stopMapCommandSent: '已发送停止建图指令',
  stopMapFailed: '停止建图失败',
  syncMapCommandSent: '地图同步指令已发送',
  syncMapFailed: '地图同步失败',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  mapListFetchFailed: '地图列表获取失败',
  missingMapId: '缺少地图 ID，无法查看详情',
  routeNotFound: '未找到地图详情路由，请在菜单里配置 path=/map_detail（与 /live_stream 同为 robot_dog 子路由、绝对 path）',
}